/* This example requires Tailwind CSS v2.0+ */
import { Primary } from "../buttons/Primary";
import { Fifth } from "../buttons/Fifth";

const features = [
  {
    description:
      "Vive cada instante los cambios que realices a tus créditos.",
  },
  {
    description:
      "Cuidamos tu salud financiera, por eso en Galilea recibirás recordatorios de pagos junto con toda la información a tu dispocisión para estar al día.",
  },
  {
    description:
      "Realiza aumentos de cupo y actualiza tu información desde tu cuenta.",
  },
  {
    description:
      "Soporte 24/7 a través de nuestro canal de whatsapp.",
  },
];

export function FeatureTwo() {
  return (
    <div className="overflow-hidden bg-grayM font-walsheim text-tdark">
      <div className="max-w-7xl mx-auto py-28 px-6 lg:px-8">
        <div className="lg:flex">
          <div className="relative block lg:w-1/2">
            <div className="lg:absolute lg:w-120 h-auto lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2">
              <img
                className="w-110 h-auto"
                src="/png/featureTwo.png"
                alt="Crear-cuenta"
              />
            </div>
          </div>
          <div className="lg:w-1/2 lg:pl-20">
            <div className="">
              <h2 className="pt-8 lg:pt-0 text-4xl font-bold tracking-tight sm:text-5xl lg:pr-20">
                Ten el control de tus finanzas con tu cuenta Galilea
              </h2>
            </div>
            <dl className="my-10 space-y-10">
              <ul className="space-y-4 marker:text-tdark list-disc text-lg">
                {features.map((feature, idx) => (
                  <li key={idx} className="ml-4">
                    <dd className="mt-2 text-lg">{feature.description}</dd>
                  </li>
                ))}
              </ul>
              <div className="pt-4">
                <div className="lg:flex">
                  <div className="block lg:w-1/2 py-2">
                    <a
                      href="/registrarse"
                      className="w-52 pb-10 md:mx-0 mx-auto"
                    >
                      <Primary text="Aplicar ahora" />
                    </a>
                  </div>
                  <div className="pl-2 block lg:w-1/2 py-2">
                    <a href="/tarifas" className="w-52 pb-10 md:mx-0 mx-auto">
                      <Fifth text="Tasas y tarifas" />
                    </a>
                  </div>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
